export default {
  about: "Über uns",
  courses: "Kurse",
  pricing: "Preise",
  blog: "Blog",
  contact: "Kontakt",
};
